import { render, staticRenderFns } from "./Formulation.vue?vue&type=template&id=7f5a2589&"
import script from "./Formulation.vue?vue&type=script&lang=js&"
export * from "./Formulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports